module.exports = __webpack_public_path__ + "static/media/karta_vespa3.53b1dbde.png";